import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Label for an input field that allows users to add a description of the package',
    defaultMessage: 'Package Description',
    id: '6P3dhR',
  },
  reasonForField: {
    description:
      'Text explaining a new regulation from the "Carta Porte" bureau of Mexico. The regulation requires that all package travelling in Mexico have a document describing the contents of each package.',
    defaultMessage: 'For all shipments in Mexico, the Carta Porte requires a description of the package contents.',
    id: 'v79hCM',
  },
  characterMax: {
    description: 'Label indicating that a form field accepts a maximum of 35 characters',
    defaultMessage: 'Maximum of {charMax} characters',
    id: 'slOPrj',
  },
  charactersLeft: {
    description:
      'Label for a form field that tells users how many remaining characters they can type before the max character found is reached',
    defaultMessage: '({remainingCount, plural, one {# remaining} other {# remaining} })',
    id: '6ND9oz',
  },
  required: {
    description: 'Error message telling users that the form field is required for any shipments within Mexico.',
    defaultMessage: 'This field is required to ship within Mexico. <a>Learn more</a>',
    id: '8DNRXI',
  },
  multiPackage: {
    description:
      'A message indicating to users that if they click the button, they will be able to view the values entered into the form for the "package description" field. Users will be presented with this message whenever their shipment has multiple packages associated with it, hence our "multi-package" abbreviation in English.',
    defaultMessage: '<button>View package description</button> for multi-package shipment.',
    id: 'vKz3rC',
  },
});
